import { render, staticRenderFns } from "./poiCategoriesDialog.vue?vue&type=template&id=dc0a8ed2&"
import script from "./poiCategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./poiCategoriesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports